import api from "../libs/api";

export default {

getcustomFields: (formId = null, page = 1, itemsPerPage = 15) => {
  return new Promise((resolve, reject) => {
    api()
      .get(`/custom-fields`, {
        params: {
          page,
          per_page: itemsPerPage,
          formId,
        },
      })
      .then(({ status, data }) => {
        if (status === 200 || status === 201) resolve(data);
        throw new Error(`Failed with status: ${status}`);
      })
      .catch((error) => reject(error));
  });
},

  postCustomFields: (data) => {
    return new Promise((resolve, reject) => {
      api()
        .post("/custom-fields", data)
        .then(({ status, data }) => {
          if (status === 200 || status === 201) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch((error) => reject(error));
    });
  },

  reorderCustomFields: (fields) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/custom-fields/reorder`, { fields }) // send as { fields: [...] }
        .then(({ status, data }) => {
          if (status === 200 || status === 201) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch((error) => reject(error));
    });
  },

  updateCustomField: (id, data) => {
    return new Promise((resolve, reject) => {
      api()
        .put(`/custom-fields/${id}`, data)
        .then(({ status, data }) => {
          if (status === 200 || status === 201) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch((error) => reject(error));
    });
  },


  deleteCustomField: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/custom-fields/${id}`)
        .then(({ status, data }) => {
          if (status === 200 || status === 204) resolve(data);
          else reject(new Error(`Failed with status: ${status}`));
        })
        .catch((error) => reject(error));
    });
  },
  
  getLookups: (lookup = "", itemsPerPage = 100) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/lookups`, {
          params: {
            lookup,
            itemsPerPage,
          },
        })
        .then(({ status, data }) => {
          if (status === 200 || status === 201) resolve(data.data ?? data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch((error) => reject(error));
    });
  },
};
